<template>
  <div class="hello">
    <remindListTop @event3="change3($event)" @transformVal="getVal" @fatherMethod="getremindlist" @exportMethod="exportHandle" :exportStatus="exportLoading"></remindListTop>
    <!-- <idCard v-if="isHandled==0"></idCard>
      <idCardProcessed v-if="isHandled==1"></idCardProcessed> -->
    <div class="contract">
      <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>通知</el-breadcrumb-item>
            <el-breadcrumb-item>待办事项</el-breadcrumb-item>
            <el-breadcrumb-item>身份证到期提醒</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span v-show="isHandled =='0'">待处理</span>
              <span v-show="isHandled =='1'">已处理</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="idCardTable">
          <el-table :data="tableData" :max-height="tableHeight-180" style="width: 100%" stripe v-loading="listLoading">
            <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="{$index}">
                <span>{{(Number(remindQuery.currpage) - 1) * Number(remindQuery.pagecount) + Number($index) + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="项目名称" prop="StrObjName" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="姓名" prop="StrEmpName" min-width="70px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="合同（协议）类型" prop="StrContractType" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="身份证有效期终止时间" min-width="100px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.DtIcCareEdate=='2999-12-31'">长期</span>
                <span v-else>{{isNull(scope.row.DtIcCareEdate)?'':scope.row.DtIcCareEdate.substring(0, 10)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="身份证有效期提醒" min-width="140px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span style="color: #F78500;">{{(!isNull(scope.row.DtIcCareEdate))?(diffDate(scope.row.DtIcCareEdate)):'未填身份证有效期终止时间'}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" min-width="210px">
              <template slot-scope="scope">
                <el-button type="success" size="small" plain v-if="isHandled =='0'" @click="changeTime(scope.row)">更改有效期</el-button>
                <el-button type="warning" size="small" plain @click="addHandle(scope.row)" v-if="isHandled =='0'">确认处理</el-button>
                <el-button type="warning" size="small" plain @click="revokeHandle(scope.row)" v-if="isHandled == '1'">撤销处理</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-show="totalcount>0">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
          </div>

          <el-dialog title="确认处理" :visible.sync="dialogVisible" width="30%">
            <span>若您已在线下完成处理，无需再进行其他线上操作，请点击确认</span>
            <span slot="footer" class="dialog-footer">
              <button class="clear" @click="dialogVisible = false">取消</button>
              <button class="search" @click="changeSolve" style="margin-left:10px;font-weight:600">确定</button>
            </span>
          </el-dialog>
          <el-dialog title="撤销处理" :visible.sync="dialogVisible3" width="30%">
            <span>点击“撤销处理”后，本条待办事项将重新在“待办事项”列表中</span>
            <span slot="footer" class="dialog-footer">
              <button class="clear" @click="dialogVisible3 = false">取消</button>
              <button class="search" @click="revokeSubmit" style="margin-left:10px;font-weight:600">确定</button>
            </span>
          </el-dialog>
          <el-dialog title="更改有效期" :visible.sync="dialogVisible2" width="30%">
            <span>请选择新的身份证有效终止时间</span>
            <div class="dataSele">
              <el-date-picker v-model="value1" type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" :disabled="checked"></el-date-picker>
            </div>
            <div class="idcardChecked" style="margin-top:20px">
              <el-checkbox v-model="checked" @change="changeIdcardLong">长期</el-checkbox>
            </div>
            <span slot="footer" class="dialog-footer">
              <button class="clear" @click="dialogVisible2 = false">关闭</button>
              <button class="search" @click="confirmChangeDate()" style="margin-left:10px;font-weight:600">确定</button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import {
    parseTime
  } from './../../utils' //格式化时间格式
  import remindListTop from "./components/remindListTop.vue";
  export default {
    components: {
      remindListTop,
      parseTime
    },
    data() {
      return {
        tableHeight: 0,
        checked: false,
        pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() > Date.now();
          // },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        },
        listLoading: false,
        isHandled: 0,
        emprow: "",
        totalcount: null,
        currpage: 1,
        status: 0,
        value1: "",
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        currentPage3: 1,
        remindQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 10,
          currpage: 1,
          content: 'cardid',
          strstatus: "0",
          strempname: ""
        },
        exportQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 100000,
          currpage: 1,
          content: 'cardid',
          strstatus: "0",
          strempname: ""
        },
        pagecount: 10,
        pageSize: 10,
        tableData: [],
        //确认处理参数-档案号
        strfileno: '',
        //导出按钮加载状态
        exportLoading: false,
        info: {}
      }
    },
    mounted() {
      this.calHeight();
      this.getremindlist();
    },
    methods: {
      //一键导出
      exportHandle() {
        this.exportLoading = true
        xz.outputQueryEmpCust(this.exportQuery).then(res => {
          // console.log('process', res)
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/xlsx`
            })
            let aLink = document.createElement("a")
            aLink.download = '导出列表.xlsx'; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.expLoading = false;
          } else {
            this.$message({
              message: "导出错误，请稍后再试",
              type: "error"
            });
          }
          this.exportLoading = false
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        // console.log('isnull',o)
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
      },
      change3(data) {
        // console.log('change3',data)
        this.isHandled = data;
        this.remindQuery.strstatus = data
        this.remindQuery.currpage = 1
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      //分页转跳
      handleCurrentChange(val) {
        this.currpage = `${val}`;
        this.remindQuery.currpage = `${val}`;
        this.getremindlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.pageSize = parseInt(val);
        this.getremindlist();
      },
      //确认处理
      addHandle(row) {
        this.info = row;
        this.dialogVisible = true;
        this.strfileno = row.StrFileNo
      },
      //确认处理
      changeSolve() {
        let d = {
          status: 1, //1 处理，0 退回
          content: 'cardid',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "处理成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible = false;
        });
      },
      //确认撤销
      revokeHandle(row) {
        this.info = row;
        this.dialogVisible3 = true;
        this.strfileno = row.StrFileNo
      },
      //确认撤销处理
      revokeSubmit() {
        let d = {
          status: 0, //1 处理，0 退回
          content: 'cardid',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "撤销成功！",
              type: "success"
            });
            this.dialogVisible3 = false;
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible3 = false;
        });
      },
      //修改弹窗
      changeTime(row) {
        if (row.DtIcCareEdate) {
          this.emprow = row;
          let endEate = row.DtIcCareEdate.split('/').join('-')

          if (row.DtIcCareEdate == '2999-12-31') {
            this.checked = true
            this.value1 = ''
          } else {
            this.checked = false
            if (this.isNull(row.DtIcCareEdate)) {
              this.value1 = parseTime(new Date(), '{y}-{m}-{d}')
            } else {
              this.value1 = endEate
            }
          }
        }
        this.dialogVisible2 = true;
        // row.DtIcCareEdate=='2999-12-31' ? this.checked = true : this.checked = false;
        // row.DtIcCareEdate=='2999-12-31' ? this.value1 = '' : this.value1 = endEate
      },
      changeIdcardLong() {
        this.value1 = ""
      },
      //确认修改
      confirmChangeDate() {
        if (this.isNull(this.value1) && this.checked == false) {
          this.$message({
            message: "请选择日期",
            type: "warning"
          });
          return false
        } else {
          let date = '';
          this.checked ? date = "2999-12-31" : date = this.value1
          const data = {
            tableid: "XZ_emp_UserBase",
            excelpath: this.emprow.StrExcelPath,
            execlline: this.emprow.IntExcelLine,
            cluname: "DtIcCareEdate",
            cluvalue: date
          };
          let d = {
            type: 1,
            StrExcelPath: this.emprow.StrExcelPath,
            IntExcelLine: this.emprow.IntExcelLine,
            DtIcCareEdate: date
          }
          xz.editEmployeeInfo(d).then(res => {
            if (res == true) {
              this.$message({
                message: "信息修改成功！",
                type: "success"
              });
            } else {
              this.$message.error(res.msg);
            }
            this.dialogVisible2 = false;
            this.getremindlist();
            this.emprow = "";
          });
        }
      },
      //获取待办事项列表
      getremindlist() {
        // console.log('待办事项列表', this.remindQuery)
        // this.tableData = []
        this.listLoading = true
        xz.getremindlist(this.remindQuery, localStorage.loginRoletype).then(res => {
          console.log('待办事项列表0', res)
          if (res) {
            if (res.data && res.data.length > 0) {
              let i = 1 + (this.currpage - 1) * 10;
              // res.data.forEach(l => {
              //   l.DtIcCareEdate ? (l.DtIcCareEdate = l.DtIcCareEdate.substring(0, 10)) : '-';
              //   l['num'] = i++;
              // });
              this.tableData = res.data;
              this.totalcount = parseInt(res.count);
            } else {
              this.tableData = []
              this.totalcount = 0
            }
          }
          this.listLoading = false
        })
      },
      //计算两个日期相差年月日
      diffDate(date1) {
        let begin = new Date(date1)
        let end = new Date();
        // console.log('timeff',begin)
        // 如果开始时间晚于结束时间，交换日期，并记录交换状态
        let swap = false;
        if (begin > end) {
          let tmp = begin;
          begin = end;
          end = tmp;
          swap = true;
        }
        // 分别取二个日期的年、月、日值
        let d1 = begin.getDate();
        let m1 = begin.getMonth() + 1;
        let y1 = begin.getFullYear();
        let d2 = end.getDate();
        let m2 = end.getMonth() + 1;
        let y2 = end.getFullYear();
        // 获取每个月的天数，这里要注意一下闰年的2月
        var getMonthDays = function (y, m) {
          var aMonthDays = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
          if (m == 2 && ((y % 400 == 0) || (y % 4 == 0 && y % 100 != 0))) {
            return 29;
          }
          return aMonthDays[m];
        };

        let y, m, d
        let tempD = 0
        let tmpM = 0
        let tmpY = 0

        // 计算日，不足时向月份借
        if (d2 >= d1) {
          d = d2 - d1
        } else {
          tmpM = -1
          d = getMonthDays(y1, m1) + d2 - d1
        }

        // 计算月，不足时向年份借
        if (m2 + tmpM >= m1) {
          m = m2 + tmpM - m1
        } else {
          tmpY = -1
          m = 12 + m2 + tmpM - m1
        }

        // 计算年
        y = y2 + tmpY - y1

        // 拼接距离字符串 输出格式如："5天"， "5月 05天"， "5年 05月 05日"
        let str = "";
        if (y > 0) {
          str = y + '年' + ("0" + m).substr(-2) + "个月" + ("0" + d).substr(-2) + '天'
        } else if (m > 0) {
          str = m + "个月" + ("0" + d).substr(-2) + '天'
        } else if (d > 0) {
          str = d + '天'
        }
        return (swap ? "剩余" : "已过期") + str
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style>
  .idcardChecked .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #19bd92 !important;
  }
</style>